import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { wait } from '../../../utils/utils';
import NavigateGif from '../../ui/NavigateGif';
import classes from './DelayNavigatePage.module.css';

const DelayNavigatePage = () => {

    const { link } = useParams();

    useEffect(() => {
        (async () => {
            if (link) {
                let decodeLink = decodeLinkIfNeeded(link);
                await wait(window.config.delayNavigatePageTime);
                window.location.href = decodeLink;
            }
        })()
    }, [link])

    const decodeLinkIfNeeded = (link) => {
        if (link.startsWith('ENCODED_')) {
            const base64Link = link.replace('ENCODED_', '');
            return decodeURIComponent(atob(base64Link));
        }
        return link;
    };

    return (
        <div className={classes.DelayNavigatePage}>
            <NavigateGif />
        </div>

    );
}

export default DelayNavigatePage;